import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import http from "../../common/http-common";
import CssClass from "../../Styles/common.module.css";
import TicketListHistoryTable from "../../components/Ticket/TicketList/TicketListHistoryTable";
import { GetPagePermissionFn } from "../../common/authority";

const PAGE_NAME = "TicketListHistory.js_";
const MODULE_ID = "WEB_RPT_001";

const TicketListHistory = (props) => {
  document.title = common.c_TITLE + " - Ticket List History";
  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [allData, setAllData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [searchData, setSearchData] = useState({
    SEARCH_TICKET_NO: "",
    TICKET_STATUS: [],
    ORGANIZATION: [],
    SYSTEM: [],
    CATEGORY: [],
    PRIORITY: []
  });

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [disabledField, setDisabledField] = useState(false);

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [dataToBeSelect, setDataToBeSelect] = useState({
    TicketStatus: [],
    Organization: [],
    System: [],
    Category: [],
    Priority: [],
  });

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  function searchAllTicket() {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        if (
          startDate === null &&
          searchData.SEARCH_TICKET_NO === '' && 
          searchData.TICKET_STATUS.length === 0 &&
          searchData.ORGANIZATION.length === 0 &&
          searchData.SYSTEM.length === 0 &&
          searchData.CATEGORY.length === 0 &&
          searchData.PRIORITY.length === 0 
        ) {
          toast.error("Please select at least one field to search data.");
        }
        else {
          onLoadingHandler(true, "Getting Tickets, please wait...");

          setAllData([]);

          const listItems = [];

          const ticketStatusValue =
              searchData.TICKET_STATUS !== undefined &&
              Object.keys(searchData.TICKET_STATUS).length !== 0
                ? searchData.TICKET_STATUS.map((m) => m.value).join(",")
                : "";

          const orgValue = searchData.ORGANIZATION !== undefined &&
          Object.keys(searchData.ORGANIZATION).length !== 0
            ? searchData.ORGANIZATION.map((m) => m.value).join(",")
            : "";

          const systemValue = searchData.SYSTEM !== undefined &&
          Object.keys(searchData.SYSTEM).length !== 0
            ? searchData.SYSTEM.map((m) => m.value).join(",")
            : "";
    
          const categoryValue = searchData.CATEGORY !== undefined &&
          Object.keys(searchData.CATEGORY).length !== 0
            ? searchData.CATEGORY.map((m) => m.value).join(",")
            : "";

          const priorityValue = searchData.PRIORITY !== undefined &&
          Object.keys(searchData.PRIORITY).length !== 0
            ? searchData.PRIORITY.map((m) => m.value).join(",")
            : "";  
    
          const ticketNoSelected =
            searchData.SEARCH_TICKET_NO === undefined
              ? ""
              : searchData.SEARCH_TICKET_NO.trim();
    
          var newStartDate = "";
          var newEndDate = "";
    
          if (startDate === null && endDate === null) {
            newStartDate = "";
            newEndDate = "";
          } else if (startDate !== null && endDate === null) {
            newStartDate = common.c_Dis_DateTime(startDate).val;
            newEndDate = "";
          } else {
            newStartDate = common.c_Dis_DateTime(startDate).val;
            newEndDate = common.c_Dis_DateTime(endDate).val;
          }
    
          http
            .get(
              "api/ticket/GetAllTickets?_startDate=" +
                newStartDate +
                "&_endDate=" +
                newEndDate +
                "&_status=" +
                ticketStatusValue +
                "&_org=" +
                orgValue +
                "&_system=" +
                systemValue +
                "&_category=" +
                categoryValue +
                "&_priority=" +
                priorityValue +
                "&_ticketNo=" +
                ticketNoSelected +
                "&_user=" +
                userId,
              { timeout: 10000000 }
            )
            .then((response) => {
              if (response.data.length > 0) {
                response.data.forEach((data, counter) => {
                  listItems.push({
                    key: counter,
                    TICKET_NUM: data.TICKET_NUM,
                    ORG_ID: data.ORG_ID,
                    ORG_NAME: data.ORG_NAME,
                    SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                    SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                    SUBJECT: data.SUBJECT,
                    TICKET_DETAILS: data.TICKET_DETAILS,
                    CREATE_BY: data.CREATE_BY,
                    CREATE_NAME: data.CREATE_NAME,
                    CREATE_DATETIME: data.CREATE_DATETIME,
                    TICKET_CATEGORY_ID: data.TICKET_CATEGORY_ID,
                    TICKET_CATEGORY_NAME: data.TICKET_CATEGORY_NAME,
                    TICKET_PRIORITY_TYPE_ID: data.TICKET_PRIORITY_TYPE_ID,
                    TICKET_PRIORITY_TYPE_NAME: data.TICKET_PRIORITY_TYPE_NAME,
                    TICKET_STATUS_TYPE_ID: data.TICKET_STATUS_TYPE_ID,
                    TICKET_STATUS_TYPE_NAME: data.TICKET_STATUS_TYPE_NAME,
                    ACKNOWLEDGED_BY: data.ACKNOWLEDGED_BY,
                    ACKNOWLEDGED_NAME: data.ACKNOWLEDGED_NAME,
                    TARGET_MANDAYS: data.TARGET_MANDAYS,
                    TOTAL_COMPLETE_TIME: data.TOTAL_COMPLETE_TIME,
                    ATTACHMENT_ID: data.ATTACHMENT_ID,
                    INTERNAL_NOTE: data.INTERNAL_NOTE,
                    STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                    UPDATE_ID: data.UPDATE_ID,
                    UPDATE_NAME: data.UPDATE_NAME,
                    UPDATE_DATETIME: data.UPDATE_DATETIME,
                  });
                });
              }
              setAllData(listItems);
            })
            .catch((err) => {
              toast.error("Error on getting ticket list. Please try again.");
              common.c_LogWebError(PAGE_NAME, functionName, err);
            })
            .finally(() => {
              onLoadingHandler(false, "Loading...");   
            });
        }     
      } catch (err) {
        toast.error("Error on getting ticket list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Ticket Status Type";
        setLoading(true);
        setLoadingText("Getting Ticket Status Type List, please wait...");
        http
          .get("api/ticket/GetTicketStatus?_user=" + userId)
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].TICKET_STATUS_TYPE_ID,
                value: response.data[i].TICKET_STATUS_TYPE_ID,
                label: response.data[i].TICKET_STATUS_TYPE_NAME,
              });
            }
            // setTicketStatus(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              TicketStatus: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting ticket status. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          });
      } catch (err) {
        toast.error("Error on getting ticket status. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Company";
        setLoading(true);
        setLoadingText("Getting Company List, please wait...");
        http
          .get("api/ticket/GetOrgList?_user=" + userId)
          .then((response) => {
            if (response.data[0].ORG_CATEGORY_NAME !== "CUSTOMER") {
              const listItems = [];
              for (var i = 0; i < response.data.length; i++) {
                listItems.push({
                  key: response.data[i].ORG_ID,
                  value: response.data[i].ORG_ID,
                  label: response.data[i].ORG_NAME,
                });
              }
              // setOrgData(listItems);
              setDataToBeSelect((prevState) => ({
                ...prevState,
                Organization: [...listItems],
              }));
            } else {
              setDisabledField(true);
              const listItems = [];
              for (var i = 0; i < response.data.length; i++) {
                listItems.push({
                  key: response.data[i].ORG_ID,
                  value: response.data[i].ORG_ID,
                  label: response.data[i].ORG_NAME,
                });
              }
              setSearchData((prevState) => ({
                ...prevState,
                ORGANIZATION: [...listItems],
              }));
            }   
          })
          .catch((err) => {
            toast.error("Error on getting organization list. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          });
      } catch (err) {
        toast.error("Error on getting organization list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All System ";
        setLoading(true);
        setLoadingText("Getting System List, please wait...");

        const orgSelected =
          searchData.ORGANIZATION !== undefined && Object.keys(searchData.ORGANIZATION).length !== 0
            ? searchData.ORGANIZATION.map((o) => o.key)
            : "";

        http
          .get(
            "api/ticket/GetSystemList?_user=" + userId + "&_org=" + orgSelected
          )
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].SYSTEM_MST_ID,
                value: response.data[i].SYSTEM_MST_ID,
                label: response.data[i].SYSTEM_MST_NAME,
              });
            }
            // setSystemData(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              System: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting system. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting system. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }, [reload, searchData.ORGANIZATION, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Category";
        setLoading(true);
        setLoadingText("Getting Category List, please wait...");
        http
          .get("api/ticket/GetCategoryList?_user=" + userId)
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].TICKET_CATEGORY_ID,
                value: response.data[i].TICKET_CATEGORY_ID,
                label: response.data[i].TICKET_CATEGORY_NAME,
              });
            }
            // setCategoryData(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              Category: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting category. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          });
      } catch (err) {
        toast.error("Error on getting category. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Priority Type";
        setLoading(true);
        setLoadingText("Getting Priority Type List, please wait...");
        http
          .get("api/ticket/GetPriorityList?_user=" + userId)
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].TICKET_PRIORITY_TYPE_ID,
                value: response.data[i].TICKET_PRIORITY_TYPE_ID,
                label: response.data[i].TICKET_PRIORITY_TYPE_NAME,
              });
            }
            // setPriorityData(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              Priority: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting priority type. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
      } catch (err) {
        toast.error("Error on getting priority type. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }   
  }, [reload, actionAuthority, userId]);

  //#region Event Handlers
  const selectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = selectionHandler.name;
      setInputError((prevState) => ({
        ...prevState,
        [field]: "",
      }));
      setAllData((prevState) => ({
        ...prevState,
        [field]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      setSearchData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const selectOrgHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectOrgHandler.name;

      setSearchData((prevState) => ({
        ...prevState,
        ORGANIZATION: [...val],
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const filterSelectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = filterSelectionHandler.name;
      setSearchData((prevState) => ({
        ...prevState,
        [field]: [...val], 
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };
  //#endregion

  //#region Export Excel
  const onExcelHandler = () => {
    const ticketStatusValue =
      searchData.TICKET_STATUS !== undefined &&
      Object.keys(searchData.TICKET_STATUS).length !== 0
        ? searchData.TICKET_STATUS.map((m) => m.value).join(",")
        : "";

    const orgValue = searchData.ORGANIZATION !== undefined &&
      Object.keys(searchData.ORGANIZATION).length !== 0
        ? searchData.ORGANIZATION.map((m) => m.value).join(",")
        : "";

    const systemValue = searchData.SYSTEM !== undefined &&
      Object.keys(searchData.SYSTEM).length !== 0
        ? searchData.SYSTEM.map((m) => m.value).join(",")
        : "";
  
    const categoryValue = searchData.CATEGORY !== undefined &&
      Object.keys(searchData.CATEGORY).length !== 0
        ? searchData.CATEGORY.map((m) => m.value).join(",")
        : "";

    const priorityValue = searchData.PRIORITY !== undefined &&
      Object.keys(searchData.PRIORITY).length !== 0
        ? searchData.PRIORITY.map((m) => m.value).join(",")
        : "";  

    const ticketNoSelected =
      searchData.SEARCH_TICKET_NO === undefined
        ? ""
        : searchData.SEARCH_TICKET_NO.trim();

    var newStartDate = "";
    var newEndDate = "";

    if (startDate === null && endDate === null) {
      newStartDate = "";
      newEndDate = "";
    } else if (startDate !== null && endDate === null) {
      newStartDate = common.c_Dis_DateTime(startDate).val;
      newEndDate = "";
    } else {
      newStartDate = common.c_Dis_DateTime(startDate).val;
      newEndDate = common.c_Dis_DateTime(endDate).val;
    }
    window.open(
      common.c_getApiUrl() +
        "api/ticket/ExportExcel?_startDate=" +
        newStartDate +
        "&_endDate=" +
        newEndDate +
        "&_status=" +
        ticketStatusValue +
        "&_org=" +
        orgValue +
        "&_system=" +
        systemValue +
        "&_category=" +
        categoryValue +
        "&_priority=" +
        priorityValue +
        "&_ticketNo=" +
        ticketNoSelected +
        "&_user=" +
        userId
    );
  };
  //#endregion

  return (
    <>
      <Comp.Header>Ticket List History</Comp.Header>

      <Comp.SearchPanel onSubmit={onReloadHandler}>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Created Date
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.DateTimePicker
              selectsRange
              onChange={(dates) => setDateRange(dates)}
              startDate={startDate}
              endDate={endDate}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Ticket #</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Input
              id="SEARCH_TICKET_NO"
              type="text"
              className="form-control"
              isSearch={true}
              value={searchData.SEARCH_TICKET_NO}
              onChange={inputUnrequiredHandler}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Ticket Status
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              // styles={{
              //   // Fixes the overlapping problem of the component
              //   menu: (provided) => ({ ...provided, zIndex: 9999 }),
              // }}
              id="TICKET_STATUS"
              // options={TicketStatus}
              options={dataToBeSelect.TicketStatus}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              value={searchData.TICKET_STATUS}
              onChange={(val) => filterSelectionHandler(val, "TICKET_STATUS")}
              // allowSelectAll
              isMulti
            />
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Company</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="ORGANIZATION"
              isDisabled={disabledField}
              options={dataToBeSelect.Organization}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              value={searchData.ORGANIZATION}
              // onChange={(val) => filterSelectionHandler(val, "ORGANIZATION")}
              // allowSelectAll
              onChange={selectOrgHandler}
              isMulti={!disabledField}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>System</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="SYSTEM"
              options={dataToBeSelect.System}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              value={searchData.SYSTEM}
              onChange={(val) => filterSelectionHandler(val, "SYSTEM")}
              isMulti
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Category</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="CATEGORY"
              options={dataToBeSelect.Category}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              value={searchData.CATEGORY}
              onChange={(val) => filterSelectionHandler(val, "CATEGORY")}
              isMulti
            />
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Priority</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="PRIORITY"
              options={dataToBeSelect.Priority}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              value={searchData.PRIORITY}
              onChange={(val) => filterSelectionHandler(val, "PRIORITY")}
              isMulti
            />
          </td>
        </tr>
      </Comp.SearchPanel>
      <div className={CssClass.btnWrapper}>
        <Comp.Button id="btnSearch" type="general" onClick={searchAllTicket}>
          SEARCH
        </Comp.Button>
        <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT
        </Comp.Button>
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>History of Ticket List</h3> */}
        {/* <hr /> */}
        <div style={{ width: "100%" }}>
          <TicketListHistoryTable
            page={PAGE_NAME}
            module={MODULE_ID}
            data={allData}
            dataToBeSelect={dataToBeSelect}
            onReload={onReloadHandler}
            onLoading={onLoadingHandler}
            // actionAuthority={actionAuthority}
          />
        </div>
      </div>
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default TicketListHistory;
